import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentLanguage } from '../../../../store/application/thunks';

const LANG_MAP = {
  'pt-BR': { flag: '🇧🇷', label: 'Português' },
  'pt-br': { flag: '🇧🇷', label: 'Português' },
  'en':    { flag: '🇬🇧', label: 'English' },
  'es':    { flag: '🇪🇸', label: 'Español' },
};

const getFlag  = code => (LANG_MAP[code] || LANG_MAP[(code || '').toLowerCase()] || {}).flag || '🌐';
const getLabel = code => (LANG_MAP[code] || LANG_MAP[(code || '').toLowerCase()] || {}).label || code;

const LanguageSelector = ({ currentLanguage, languages }) => {
  const dispatch  = useDispatch();
  const history   = useHistory();
  const application  = useSelector(state => state.application);
  const travel       = useSelector(state => state.travel);
  const reservation  = useSelector(state => state.reservation);
  const currencies   = useSelector(state => state.currencies);
  const { widget }   = application;
  const { couponCode, utmSource, askSuiteId } = reservation;
  const { arrivalDate, departureDate, totalAdults, preSelectedRoom } = travel;
  const { code: currentCurrencyCode } = currencies.current;
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = code => {
    dispatch(
      setCurrentLanguage(
        code, arrivalDate, departureDate, couponCode,
        currentCurrencyCode, totalAdults, preSelectedRoom,
        utmSource, askSuiteId, widget, history
      )
    );
    setIsOpen(false);
  };

  if (!languages || !languages.length || !currentLanguage) return null;

  return (
    <div id="lang-selector" className={isOpen ? 'open' : ''}>
      <button id="lang-trigger" onClick={() => setIsOpen(!isOpen)}>
        <span className="lang-flag">{getFlag(currentLanguage)}</span>
        <span className="lang-arrow">▼</span>
      </button>
      <div id="lang-dropdown">
        {languages.map(lang => (
          <button
            key={lang.code}
            className={lang.code === currentLanguage ? 'active' : ''}
            onClick={() => changeLanguage(lang.code)}
          >
            <span className="flag">{getFlag(lang.code)}</span>
            {getLabel(lang.code)}
          </button>
        ))}
      </div>
    </div>
  );
};

LanguageSelector.propTypes = {
  currentLanguage: PropTypes.string.isRequired,
  languages: PropTypes.array.isRequired,
};

export default LanguageSelector;
